import type { Interest } from '@/domain/interests/entities/interest.entity'

export type InterestSortField = keyof Interest

export interface InterestsDeleteDialogState {
  isOpen: boolean
  interestId: string | null
  interestName: string
}

export const initialInterestsDeleteDialogState: InterestsDeleteDialogState = {
  isOpen: false,
  interestId: null,
  interestName: '',
}

export interface InterestFormErrors {
  name?: string
  icon?: string
}
